import React from 'react'

import '../animation/animation.css'



export default class Birds extends React.Component {
	render (){
		return (
		<div  css={{position:`absolute`,
					top:`-80px`,
					width:`100%`,
					height:`200px`,
					zIndex:`1000`
					}}>
					
			<div className="bird-container bird-container--one">
					<div className="bird bird--one"></div>
					</div>
				<div className="bird-container bird-container--two">
				<div className="bird bird--two"></div>
			</div>
			
			<div className="bird-container bird-container--three">
				<div className="bird bird--three"></div>
			</div>

		</div>	
		
		)
	}
}